module.exports = __webpack_public_path__ + "img/Soundbank Rob Jason.f004d793.png";